import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../../hooks";
import { toInternationalFormat } from "../../../utils";
import { PageHeader, Pagination } from "../../../components";
import RequestedList from "../campaign list components/CampaignRequestList";

export default function CampaignDP() {
  const axios = useAxios();

  const [loading, setLoading] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [sortBy, setSortBy] = useState("ALL");
  const [categorize, setCategorize] = useState("REQUESTED");
  const [page, setPage] = useState({ page: 1, totalCount: 0, lastCount: 0 });

  const { activeBrand, userID } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);
    if (categorize === "ACTIVE") {
      axios({
        url:
          "/user/acceptedCampaigns" +
          `?page=${page.page}&limit=10` +
          (searchKey ? `&search=${encodeURIComponent(searchKey)}` : "") +
          (sortBy ? `&requestStatus=${sortBy}` : ""),
        method: "POST",
        data: {
          provider_brandId: activeBrand.ID,
          provider_userId: userID,
        },
      }).then((response) => {
        if (response.status) {
          let arr = [];

          for (let key of response.data.sortedRequests) {
            let data = {};
            for (let fields of key.fields) {
              if (
                Object.keys(fields)[0] === "budget_min" ||
                Object.keys(fields)[0] === "budget_max" ||
                Object.keys(fields)[0] === "monthly_active_user" ||
                Object.keys(fields)[0] === "volume"
              ) {
                data[Object.keys(fields)[0]] = toInternationalFormat(
                  Object.values(fields)[0]
                );
              } else {
                data[Object.keys(fields)[0]] = Object.values(fields)[0];
              }
            }
            arr.push({
              ...data,
              previewImage: !!key.preview_image
                ? key.preview_image
                : "https://dc-chat-media.s3.ap-south-1.amazonaws.com/NaN_placeholder.png",
              status: key.status,
              audience_id: key.audience_id,
              brand_id: key.brand_id,
              campaign_id: key.campaign_id,
              brand: key.brand_info,
              user_Count: key.user_Count,
              campaignStatus: key.campaign_status,
            });
          }

          setCampaigns(arr);

          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCounts,
            lastPage: response.data.campaignData?.length < 10,
          }));
        }
      });
      setLoading(false);
    }

    if (categorize === "REQUESTED") {
      axios({
        url:
          "/user/showCampaignRequestsDP?brandId=" +
          activeBrand.ID +
          `&page=${page.page}&limit=10` +
          (searchKey ? `&search=${searchKey}` : "") +
          (sortBy ? `&requestStatus=${sortBy}` : ""),
      }).then((response) => {
        if (response.status) {
          let campaign = [];

          for (let key of response.data.sortedRequests) {
            let data = {};
            for (let fields of key.campaign_fields) {
              if (
                Object.keys(fields)[0] === "budget_min" ||
                Object.keys(fields)[0] === "budget_max" ||
                Object.keys(fields)[0] === "monthly_active_user" ||
                Object.keys(fields)[0] === "volume"
              ) {
                data[Object.keys(fields)[0]] = toInternationalFormat(
                  Object.values(fields)[0]
                );
              } else {
                data[Object.keys(fields)[0]] = Object.values(fields)[0];
              }
            }

            campaign.push({
              ...data,
              brand: key.brand_info,
              previewImage: !!key.preview_image
                ? key.preview_image
                : "https://dc-chat-media.s3.ap-south-1.amazonaws.com/NaN_placeholder.png",
              status: key.requestStatus,
              request_id: key.request_id,
              sender_brandId: key.sender_brandId,
              sender_userId: key.sender_userId,
              sender_campaignId: key.sender_campaignId,
              receiver_brandId: key.receiver_brandId,
              receiver_userId: key.receiver_userId,
              isAccepted: key.isAccepted,
              user_Count: key.user_Count,
              campaignStatus: key.campaign_status,
            });
          }

          setCampaigns(campaign);

          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCounts,
            lastPage: response.data.campaignData?.length < 10,
          }));
        }
        setLoading(false);
      });
    }
  }, [axios, sortBy, categorize, userID, activeBrand.ID, page.page, searchKey]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageHeader={"List of campaigns"}
            pageName={
              categorize === "REQUESTED"
                ? "Campaign Offers"
                : "Active Campaigns"
            }
          />
        </Grid>
      </Grid>

      <RequestedList
        page={page}
        sortBy={sortBy}
        categorize={categorize}
        setCategorize={setCategorize}
        setSortBy={setSortBy}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        campaigns={campaigns}
        component="request"
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            style={{ marginTop: "20px" }}
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
